import { createContext } from "react";
import { Endpoints } from "../../lib/endpoints";
import { usePerformRequest } from "../../lib/usePerformRequest";
import { NonPaginatedResponse } from "../../types";
import { IAvailableLoanPlansProps, ILoanProductListResponse, ILoanProductStats } from "../../types/Loan";

export interface AppContextType {
     availableLoanPlans: IAvailableLoanPlansProps[];
     loanProductStats?: ILoanProductStats;
     isLoading: boolean;
     reloadData: () => void;
}
export const AppContext = createContext<AppContextType>({
     availableLoanPlans: [],
     loanProductStats: undefined,
     isLoading: false,
     reloadData: () => {},
});
export default function AppContextProvider({ children }: { children: React.ReactNode }) {
     const {data, isLoading, reloadData} = usePerformRequest<NonPaginatedResponse<ILoanProductListResponse>>({
          method: Endpoints.GetAvailableLoanPlans().method,
          route: Endpoints.GetAvailableLoanPlans().route,
     })

     return (
          <AppContext.Provider value={{
               availableLoanPlans: data?.data?.items || [],
               loanProductStats: data?.data?.stats,
               isLoading,
               reloadData,
          }}>
               {children}
          </AppContext.Provider>
     )
}